import { render, staticRenderFns } from "./UserNameBox.vue?vue&type=template&id=146d5232&"
import script from "./UserNameBox.vue?vue&type=script&lang=js&"
export * from "./UserNameBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports